import { Button, ButtonSpinner, ButtonText, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { Image, ImageSourcePropType, Linking, Platform, SafeAreaView, StyleSheet } from 'react-native'
import antenna from '../../assets/images/antenna.png'
import { i18n } from '../../lib/i18n'
import { theme } from '../../theme'

const RETRY_FEEDBACK_DURATION = 10000

export interface BootAppFailedProps {
  onRetry: () => void
}

const BootAppFailed: FunctionComponent<BootAppFailedProps> = ({ onRetry }) => {
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      return
    }
    const timer = setTimeout(() => setIsLoading(false), RETRY_FEEDBACK_DURATION)
    return () => clearTimeout(timer)
  }, [isLoading])

  const retry = () => {
    setIsLoading(true)
    onRetry()
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.imageContainer}>
        <Image style={styles.image} source={antenna as ImageSourcePropType} resizeMode="contain" />
      </View>
      <View style={styles.textContainer}>
        <Text style={[styles.textTitle, styles.text]}>{i18n.t('offline.title')}</Text>
        <Text style={styles.text}>{i18n.t('offline.line1')}</Text>
        <Text style={styles.text}>{i18n.t('offline.line2')}</Text>
        <Button style={styles.button} variant="outline" onPress={retry}>
          {isLoading ? <ButtonSpinner /> : <ButtonText style={styles.buttonText}>{i18n.t('offline.retry')}</ButtonText>}
        </Button>
        {Platform.OS !== 'web' && (
          <Button style={styles.button} variant="link" onPress={() => Linking.openSettings()}>
            <ButtonText style={styles.buttonText}>{i18n.t('offline.openSettings')}</ButtonText>
          </Button>
        )}
      </View>
    </SafeAreaView>
  )
}

const BUTTON_WIDTH = 150

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  textContainer: {
    flex: 1,
    justifyContent: 'flex-start',
  },
  imageContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  image: {
    margin: theme.padding.x1,
  },
  textTitle: {
    fontWeight: 'bold',
  },
  button: {
    width: BUTTON_WIDTH,
    alignSelf: 'center',
  },
  buttonText: {
    flex: 1,
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
    margin: theme.padding.x1,
  },
})

export { BootAppFailed }
